import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadTranslations } from "../../i18n/core/loader";

// Thunk for loading language data
export const loadLanguageThunk = createAsyncThunk(
  "i18n/loadLanguage",
  async (language, { rejectWithValue }) => {
    try {
      // Load translations from all registered sources
      const translations = await loadTranslations(language);
      return { language, translations };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for loading specific translation modules
export const loadTranslationModuleThunk = createAsyncThunk(
  "i18n/loadTranslationModule",
  async ({ language, module }, { rejectWithValue }) => {
    try {
      // Load translations from a specific module
      const translations = await loadTranslations(language, [module]);
      return { language, module, translations };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for changing the language
export const changeLanguageThunk = createAsyncThunk(
  "i18n/changeLanguage",
  async (language, { dispatch, getState, rejectWithValue }) => {
    try {
      // Check if we already have the translations for this language
      const { i18n } = getState();

      // If we don't have the translations yet, load them
      if (
        !i18n.translations[language] ||
        Object.keys(i18n.translations[language]).length === 0
      ) {
        await dispatch(loadLanguageThunk(language)).unwrap();
      }

      // Store preference in localStorage
      localStorage.setItem("preferredLanguage", language);

      return { language };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for initializing i18n from localStorage or browser settings
export const initializeI18nThunk = createAsyncThunk(
  "i18n/initialize",
  async (_, { dispatch }) => {
    // Get language from localStorage or use browser language or default to 'en'
    const savedLanguage = localStorage.getItem("preferredLanguage");
    const browserLanguage = navigator.language.split("-")[0]; // Get language code from browser
    const language = savedLanguage || (browserLanguage === "hi" ? "hi" : "en");

    // Change to the determined language
    await dispatch(changeLanguageThunk(language)).unwrap();

    return language;
  }
);
